/**
 * Модель для работы с отчётом "Рабочее время"
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';
import { saveAs } from 'file-saver';

import { IEmployeeShort, IReportWorkingTime } from './types';
import normalizeWorkingTimeRange from '../utils/normalizeWorkingTimeRange';

import UsersService from '../services/UsersService';
import ReportService from '../services/ReportService';
import AdminService from '../services/AdminService';

interface IData {
  employees: IEmployeeShort[];
  timeTable: any[];
}

interface IList {
  data: IReportWorkingTime[] | null;
  pagesCount: number;
}

interface IState {
  data: IData;
  list: IList;
}

const initialState: IState = {
  data: {
    employees: [],
    timeTable: []
  },
  list: {
    data: null,
    pagesCount: 0
  }
};

export const reportWorkingTime = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setData(state: IState, payload: IData): IState {
      return { ...state, data: payload };
    },
    setList(state: IState, payload: IList): IState {
      return { ...state, list: payload };
    },
    resetList(state: IState): IState {
      return {
        ...state,
        list: {
          data: null,
          pagesCount: 0
        }
      };
    },
    reset(): IState {
      return { ...initialState };
    }
  },
  effects: () => ({
    async getData() {
      try {
        const [{ data: employees }, { data: timeTable }] = await Promise.all([
          UsersService.getAllEmployeesShort(),
          AdminService.getTimeTableConfig()
        ]);

        this.setData({ employees, timeTable });
      } catch (error) {
        return error;
      }
    },
    async getList(params: any) {
      const cloneParams = normalizeWorkingTimeRange(params);

      try {
        const { data } = await ReportService.getWorkingTime(cloneParams);

        this.setList(data);
      } catch (error) {
        return error;
      }
    },
    async exportList(params: any) {
      const cloneParams = normalizeWorkingTimeRange(params);
      const { from, to } = cloneParams;

      try {
        const { data } = await ReportService.getXlsxWorkingTime(cloneParams);

        saveAs(data, `Отчет по рабочему времени за период ${from} - ${to}.xlsx`);
      } catch (error) {
        return error;
      }
    }
  })
});
